/*
 * @Author: LCQ
 * @Date: 2024-08-07 10:03:28
 * @LastEditTime: 2024-09-05 15:01:16
 * @LastEditors: LCQ
 * @Description: 机动车信息
 * @FilePath: \operation.dstcar.com\src\router\motorCarMesssage\index.js
 */

export default [
  {
    path: '/motorCarMesssage/list',
    name: 'MotorCarMesssageList',
    component: () => import('@/pages/motorCarMesssage/list'),
    meta: {
      storeKey: 'oss:aftersales:app:tickets:cars'
    }
  },
  {
    path: '/motorCarMesssage/detail',
    name: 'MotorCarMesssageDetail',
    component: () => import('@/pages/motorCarMesssage/detail'),
    meta: {
      storeKey: '*'
    }
  }
]




// WEBPACK FOOTER //
// ./src/router/motorCarMesssage/index.js